<template>
    <div class="grafana-container">
      <iframe
        :src="grafanaUrl"
        class="grafana-iframe"
        frameborder="0"
        scrolling="no"
        loading="lazy"
        @load="onGrafanaLoad"
      />
      <div v-if="loading" class="grafana-loading">
        <v-progress-circular indeterminate color="primary" />
        <p>Loading Grafana Dashboard...</p>
      </div>
    </div>
</template>

<script>
import TelemetryCard from './TelemetryCard.vue'

export default {
  name: 'GrafanaChartCard',
  components: {
    TelemetryCard
  },
  props: {
    theme: {
      type: String,
      default: 'primary'
    },
    grafanaUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    onGrafanaLoad() {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.grafana-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.grafana-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 4px;
}

.grafana-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
  color: #666;
}
</style>
